import scrollLock from 'scroll-lock';

export default class Menu{
	static init(){

		document.addEventListener('bless', () => {
			const headerWrapper = document.querySelector('.nav-main');
			new Menu(headerWrapper);
		});
	}

	constructor(headerWrapper){

		this.headerWrapper = headerWrapper;
		this.logo = this.headerWrapper.querySelector('.c-header__logo');
		this.languageSwitcher = this.headerWrapper.querySelector('.c-langswitcher');
		this.hamburger = this.headerWrapper.querySelector('.c-hamburger');
		this.menu = document.querySelector('.c-menu');

		this.menuOpen = false;

		this.hamburger.addEventListener('click', e => {
			this.toggleMenu();
		});


		let FocusableElements = this.menu.querySelectorAll('li');

		const firstTarget = FocusableElements[0];
		const lastTarget = FocusableElements[FocusableElements.length - 1];

		const firstFocusableEl = firstTarget.firstElementChild;
		const lastFocusableEl = lastTarget.firstElementChild;

		window.addEventListener('keydown', e => {

			if (e.key === 'Escape') {
				this.closeMenu();
			}

			if (e.key === 'Tab' || e.key === 9) {
				if ( e.shiftKey ) /* shift + tab */ {
					if (document.activeElement === firstFocusableEl) {
						lastFocusableEl.focus();
						e.preventDefault();
					}
				} else /* tab */ {
					if (document.activeElement === lastFocusableEl) {
						firstFocusableEl.focus();
						e.preventDefault();
					}
				}
			}
		});
	}

	toggleMenu() {
		this.menuOpen ? this.closeMenu() : this.openMenu();
	}

	openMenu() {
		this.menuOpen = true;

		scrollLock.disablePageScroll();

		document.body.classList.add('has-menu-open');

		this.menu.classList.add('is-active');

		this.logo.classList.add('hide');
		this.languageSwitcher.classList.add('show');

		this.hamburger.classList.add('is-active');
		this.hamburger.setAttribute('aria-expanded', true);
		this.hamburger.setAttribute('aria-label', 'button - close navigation menu');
	}

	closeMenu() {
		if (!this.menuOpen) {
			return new Promise(resolve => {
				resolve();
			});
		}

		this.menuOpen = false;

		scrollLock.enablePageScroll();

		document.body.classList.remove('has-menu-open');

		this.menu.classList.remove('is-active');

		this.logo.classList.remove('hide');
		this.languageSwitcher.classList.remove('show');

		this.hamburger.classList.remove('is-active');
		this.hamburger.setAttribute('aria-expanded', false);
		this.hamburger.setAttribute('aria-label', 'button - open navigation menu');
	}
}
